import { Container } from './PressContainer.style';

export default Container;
